import { DataSource, FormOption } from '@qfa/forms';
import { useCameraPresetsLazyQuery } from '@kinetic-ui/data-layer';
import { useCallback } from 'react';
import { isNonNull } from 'kineticUtils';

export const useCameraPresetsDataSource = (): DataSource<
  FormOption[],
  {
    cameraId: string;
  }
> => {
  const [getPresets] = useCameraPresetsLazyQuery();

  const load = useCallback(
    async (variables: { cameraId: string }) => {
      const { data } = await getPresets({ variables });
      return (
        data?.camera?.presets?.filter(isNonNull).map((preset) => ({
          label: preset.name,
          value: preset.id,
        })) ?? []
      );
    },
    [getPresets]
  );

  return { load };
};
